import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPatch, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { QuickBooksFieldMapping, UpdateQuickBooksFieldMappingDto } from '@/types/settings';

export function useUpdateQbFieldMapping() {
  const queryClient = useQueryClient();
  return useApiMutation<QuickBooksFieldMapping, UpdateQuickBooksFieldMappingDto>({
    mutationFn: (dto) =>
      apiPatch<QuickBooksFieldMapping, UpdateQuickBooksFieldMappingDto>(
        operationsClient,
        settingsEndpoints.qbFieldMapping(),
        dto,
      ),
    onSuccess: (data) => {
      queryClient.setQueryData(settingsKeys.qbFieldMapping(), data);
      toast.success('Field mapping saved');
    },
  });
}
